// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"581848fa","902":"e536582c"}[chunkId] + ".chunk.css";
};